import { ForumPost } from "./forum/forum-post";
import type { loadForumPost } from "./forum/forum.data";

type PostData = Awaited<ReturnType<typeof loadForumPost>>;

export function ForumPostPage({ data }: { readonly data: PostData }) {
  return (
    <ForumPost
      key={`${data.room.forumSlug}/${data.postId}`}
      {...data.room}
      postId={data.postId}
      initialDetail={data.detail}
    />
  );
}
